import { identidadeSonoraService } from '@/shared/services/identidadeSonoraService';
import type { IdentidadeSonoraConfig, IdentidadeSonoraClipe } from '@/shared/types';

/** Leitura só-leitura, usada pelo Player (RPC por tela). CRUD/upload fica no repositório do
 *  módulo admin (`src/features/identidade-sonora/data`). */
export const identidadeSonoraPlayerRepository = {
  buscarParaTela(
    telaId: string,
  ): Promise<{ config: IdentidadeSonoraConfig | null; clipes: IdentidadeSonoraClipe[] }> {
    return identidadeSonoraService.buscarParaTela(telaId);
  },
};
